import React from 'react';

type ToggleSwitchProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    labelOn?: string;
    labelOff?: string;
    disabled?: boolean;
};

const ToggleSwitch = ({
    checked,
    onChange,
    labelOn = 'YES',
    labelOff = 'NO',
    disabled = false,
}: ToggleSwitchProps): JSX.Element => {
    const handleClick = (): void => {
        if (!disabled) onChange(!checked);
    };

    return (
        <button
            type="button"
            className={`toggle-switch ${checked ? 'toggle-switch--on' : 'toggle-switch--off'} ${disabled ? 'toggle-switch--disabled' : ''}`}
            onClick={handleClick}
            disabled={disabled}
            aria-pressed={checked}
            aria-label={checked ? labelOn : labelOff}
        >
            <span className="toggle-switch-label toggle-switch-label--off">{labelOff}</span>
            <span className="toggle-switch-thumb" />
            <span className="toggle-switch-label toggle-switch-label--on">{labelOn}</span>
        </button>
    );
};

export default ToggleSwitch;
